<div [class]="'d-flex align-items-center field-wrapper-'+size ">
    <!-- <div #tooltip="matTooltip" [matTooltip]="''+toolTipMsg" matTooltipClass="tooltipCss" matTooltipPosition="above">
    </div> -->
    <div style="padding-right: 4px;">
        <ng-content></ng-content>
    </div>
    <!-- tooltip.show() -->
    <button  #content type="button" *ngIf="toolTipMsg || toolTipLink" mat-icon-button class="no-hover-effect" (click)="openMsg()"
    style="position: relative; top: -2px; left: -4px;">
        <mat-icon [class]="'material-icons-outlined '+iconClass " >{{iconName}}</mat-icon>
    </button>
</div>
<ng-template #theTooltip>
    <div (click)="closeOvelay()" class="tpCss d-flex flex-column mat-elevation-z8"  [style]="'gap:4px; padding: 16px; max-width:'+toolTipWidth+'px'">
        <div *ngIf="title" class="mat-subheading-2">{{title}}</div>
        <ng-container *ngIf="toolTipLink; else showPlainText">
          <div class="eac-c1">{{ toolTipMsg }}</div>
          <a [href]="toolTipLink" target="_blank" class="moreInfo">Més informació</a>
        </ng-container>
        <ng-template #showPlainText>
          <div class="eac-c1">{{ toolTipMsg }}</div>
        </ng-template>

        <div *ngIf="actionTitle!=null">
            <button mat-button color="primary" (click)="action.emit(true)" style="position: relative; left: -8px; padding-left: 8px; padding-right: 8px;">
                {{actionTitle}} <mat-icon  *ngIf="actionIsSelect" inline="true">arrow_drop_down</mat-icon>
            </button>

        </div>
    </div>




</ng-template>
